'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.ProgressContainer = exports.IconContainer = exports.LoadingContainer = exports.Container = undefined;

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _style = require('../style');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var __makeTemplateObject = undefined && undefined.__makeTemplateObject || function (cooked, raw) {
    if (Object.defineProperty) {
        Object.defineProperty(cooked, "raw", { value: raw });
    } else {
        cooked.raw = raw;
    }
    return cooked;
};
var Container = exports.Container = _styledComponents2.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  max-width: 600px;\n  text-align: center;\n  margin: 0 auto;\n  padding: 1rem;\n"], ["\n  max-width: 600px;\n  text-align: center;\n  margin: 0 auto;\n  padding: 1rem;\n"])));
var LoadingContainer = exports.LoadingContainer = _styledComponents2.default.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  margin: 3.5rem auto 3rem;\n  text-align: center;\n  width: 210px;\n  height: 210px;\n  border: 1px solid ", ";\n  background: white;\n  box-sizing: border-box;\n  box-shadow: 0 2px 48px rgba(0, 0, 0, 0.1);\n  border-radius: 10px;\n  position: relative;\n"], ["\n  margin: 3.5rem auto 3rem;\n  text-align: center;\n  width: 210px;\n  height: 210px;\n  border: 1px solid ", ";\n  background: white;\n  box-sizing: border-box;\n  box-shadow: 0 2px 48px rgba(0, 0, 0, 0.1);\n  border-radius: 10px;\n  position: relative;\n"])), _style.COLOR_GANDALF);
var IconContainer = exports.IconContainer = _styledComponents2.default.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  width: 100%;\n  display: flex;\n  height: 110px;\n  align-items: flex-end;\n  justify-content: center;\n"], ["\n  width: 100%;\n  display: flex;\n  height: 110px;\n  align-items: flex-end;\n  justify-content: center;\n"])));
var ProgressContainer = exports.ProgressContainer = _styledComponents2.default.div(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  padding: 2px 10px;\n  width: inherit;\n  position: absolute;\n  bottom: 0;\n"], ["\n  padding: 2px 10px;\n  width: inherit;\n  position: absolute;\n  bottom: 0;\n"])));
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;
//# sourceMappingURL=LoadingIndicator.style.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/web-ui/dist/order/views/pay-page/LoadingIndicator/LoadingIndicator.style.js
// module id = 1939
// module chunks = 0